import * as React from 'react';

import {AutoplayKeyboardListenerConfigurationContext, frameworkAutoplayKeyboardListener} from './autoplayKeyboardListenerConfiguration';

const withAutoplayKeyboardListenerConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <AutoplayKeyboardListenerConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkAutoplayKeyboardListener}/>
                );
            }}
        </AutoplayKeyboardListenerConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withAutoplayKeyboardListenerConfiguration;